import { HttpContextToken } from '@angular/common/http';
import type { HttpInterceptorFn } from '@angular/common/http';

/**
 * Clave de idempotencia de una acción que mueve dinero (SPEC RN-DIN-08, RN-UI-03).
 * El formulario genera UNA clave con `crypto.randomUUID()` al crearse y la REUTILIZA en cada
 * reintento del mismo envío:
 *
 *   private readonly claveIdempotencia = crypto.randomUUID();
 *   this.http.post(url, body, { context: new HttpContext().set(IDEMPOTENCY_KEY, this.claveIdempotencia) })
 */
export const IDEMPOTENCY_KEY = new HttpContextToken<string | null>(() => null);

export const idempotenciaInterceptor: HttpInterceptorFn = (req, next) => {
  const clave = req.context.get(IDEMPOTENCY_KEY);
  if (!clave) return next(req);
  return next(req.clone({ setHeaders: { 'Idempotency-Key': clave } }));
};
